import styled from 'styled-components';
import _ButtonUpload from 'components/ButtonUpload';
import { th } from 'style/theme';

export const IntercomLink = styled.span`
  color: ${th('colors.primaryLink.default')};
  text-decoration: underline;
  cursor: pointer;
  :hover {
    color: ${th('colors.primaryLink.hover')};
  }
`;

export const ButtonUpload = styled(_ButtonUpload)`
  margin-top: 20px;
`;
